import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import { callAPI } from "../../../../../App/Helpers/callApi";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import DraggableTable from "../../../../../App/Components/Table/DraggableTable";
import { basicSort } from "../../../../../App/Helpers/BasicSort";
import FeaturedJobDetailTableCell from "./FeaturedJobDetailTableCell";
import {
  editFeaturedJobDisplay,
  getFeaturedJobDisplay,
} from "./FeaturedJobDisplayService";

function FeaturedJobsDisplayPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    card: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "100%",
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [locationData, setLocationData] = useState(false);
  const [hasNoJobs, setHasNoJobs] = useState(false);
  const [displayCarousel, setDisplayCarousel] = useState(false);
  const [horizontal, setHorizontal] = useState(false);

  const [automatic, setAutomatic] = useState("");
  const [slides, setSlides] = useState("");
  const [message, setMessage] = useState("");

  const columns = [
    { label: "Selected", propName: "selected" },
    { label: "Property", propName: "detailsPropertyAdminText" },
    { label: "", propName: "" },
  ];

  const getData = () => {
    setLoading(true);
    getFeaturedJobDisplay(selectCareersClient.id).then((response) => {
      setLocationData(response.featuredConfig?.hasLocationData);
      setHasNoJobs(response.featuredConfig?.hasNoCountMessage);
      setDisplayCarousel(response.featuredConfig?.useCarousel);
      setHorizontal(!response.featuredConfig?.carouselDisplayVertically);
      setAutomatic(
        response.featuredConfig?.automaticCarouselAfter === null
          ? ""
          : response.featuredConfig?.automaticCarouselAfter
      );
      setSlides(
        response.featuredConfig?.carouselShowCount === null
          ? ""
          : response.featuredConfig?.carouselShowCount
      );
      setMessage(
        response.featuredConfig?.noCountMessage === null
          ? ""
          : response.featuredConfig?.noCountMessage
      );
      response.properties.sort((a, b) => {
        const order = basicSort(
          a.clientFeaturedAdDetailsPropertyConfigurations[0]?.order,
          b.clientFeaturedAdDetailsPropertyConfigurations[0]?.order
        );
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      response.properties.forEach((row) => {
        row.selected =
          row.clientFeaturedAdDetailsPropertyConfigurations?.length > 0;
        row.label =
          row.clientFeaturedAdDetailsPropertyConfigurations[0]?.displayName ===
          undefined
            ? ""
            : row.clientFeaturedAdDetailsPropertyConfigurations[0]?.displayName;
      });
      setTableData(response.properties);
      setLoading(false);
    });
  };

  function saveFeaturedJobDisplay() {
    var addProperties = [];
    var newOrder = 1;

    tableData.forEach((row) => {
      if (row.selected) {
        let newProperty = {
          AvailableAdDetailsPropertyId: row.id,
          ClientId: selectCareersClient.id,
          DisplayName: row.label,
          Order: newOrder,
        };
        newOrder += 1;
        addProperties.push(newProperty);
      }
    });

    let addConfig = {
      ClientId: selectCareersClient.id,
      HasLocationData: locationData,
      HasNoCountMessage: hasNoJobs,
      NoCountMessage: message,
      UseCarousel: displayCarousel,
      AutomaticCarouselAfter: automatic,
      CarouselShowCount: slides,
      CarouselDisplayVertically: !horizontal,
    };

    let data = {
      ClientId: selectCareersClient.id,
      selectedProperties: addProperties,
      featuredConfig: addConfig,
    };

    callAPI(
      editFeaturedJobDisplay(selectCareersClient.id, data),
      "Featured Display Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getData();
    });
  }

  useEffect(() => {
    if (tableData.length > 0 && !loading) {
      var addProperties = [];
      var newOrder = 1;

      tableData.forEach((row) => {
        if (row.selected) {
          let newProperty = {
            AvailableAdDetailsPropertyId: row.id,
            ClientId: selectCareersClient.id,
            DisplayName: row.label,
            Order: newOrder,
          };

          newOrder += 1;
          addProperties.push(newProperty);
        }
      });

      let addConfig = {
        ClientId: selectCareersClient.id,
        HasLocationData: locationData,
        HasNoCountMessage: hasNoJobs,
        NoCountMessage: message,
        UseCarousel: displayCarousel,
        AutomaticCarouselAfter: automatic,
        CarouselShowCount: slides,
        CarouselDisplayVertically: !horizontal,
      };

      let data = {
        ClientId: selectCareersClient.id,
        selectedProperties: addProperties,
        featuredConfig: addConfig,
      };

      editFeaturedJobDisplay(selectCareersClient.id, data);
    }
  }, [tableData]);

  useEffect(() => {
    if (selectCareersClient !== null) {
      setHasNoJobs(false);
      setDisplayCarousel(false);
      setHorizontal(false);
      setAutomatic("");
      setSlides("");
      setMessage("");
      getData();
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className={classes.root}>
        <Grid container spacing={1} className={classes.card}>
          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid xs={12} sm={4} item>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={hasNoJobs}
                        onChange={() => setHasNoJobs(!hasNoJobs)}
                      />
                    }
                    label="Has No Jobs Message"
                  />
                </Grid>
                <Grid xs={12} sm={4} item>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={displayCarousel}
                        onChange={() => setDisplayCarousel(!displayCarousel)}
                      />
                    }
                    label="Display as Carousel"
                  />
                </Grid>
                <Grid xs={12} sm={4} item>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={horizontal}
                        onChange={() => setHorizontal(!horizontal)}
                      />
                    }
                    label="Display Carousel Horizontally"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    placeholder="Automatic Carousel After"
                    label="Automatic Carousel After"
                    variant="standard"
                    fullWidth
                    required
                    type="number"
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={automatic}
                    onChange={(e) => setAutomatic(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    placeholder="Slides in Carousel (default: 2)"
                    label="Slides in Carousel (default: 2)"
                    variant="standard"
                    fullWidth
                    required
                    type="number"
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={slides}
                    onChange={(e) => setSlides(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    placeholder="No Jobs Message"
                    label="No Jobs Message"
                    variant="standard"
                    fullWidth
                    required
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} container justifyContent="flex-end">
                  <Button
                    style={{ marginTop: "10px", marginRight: "8px" }}
                    className={classes.sensitiveButton}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => saveFeaturedJobDisplay()}
                  >
                    Save Information
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Grid item xs={12} sm={12}></Grid>
          <DraggableTable
            columns={columns}
            tableData={tableData}
            setTableData={setTableData}
            rowComponent={FeaturedJobDetailTableCell}
            loading={false}
          />
        </Grid>
      </div>
    </>
  );
}

export default FeaturedJobsDisplayPage;
